import { Notify } from "../../../../components-shared/utils/notify.js";
import { IProductWithVariants } from "./variant-selector-base.js";

const $ = window.jQuery;
declare global {
    interface Window {
        createVariantSelector: (name: string, selectorContainerElement: HTMLElement, product: IProductWithVariants, variantTypeId: number, translations: Map<string, string>, showPricesInclVat: boolean, loadAdditionalInfo: boolean) => any;
    }
}

window.createVariantSelector = async function (name: string, selectorContainerElement: HTMLElement, product: IProductWithVariants, variantTypeId: number, translations: Map<string, string>, showPricesInclVat: boolean, loadAdditionalInfo: boolean): Promise<any> {
    switch (name) {
        case 'dropdownvariant':
            const dd1Module = await import('./dropdown-variant-selector-v1.js');
            return new dd1Module.DropDownVariantSelectorV1(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'dropdownvariant2':
            const dd2Module = await import('./dropdown-variant-selector-v2.js');
            return new dd2Module.DropDownVariantSelectorV2(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'dropdownvariant3':
            const dd3Module = await import('./dropdown-variant-selector-v3.js');
            return new dd3Module.DropDownVariantSelectorV3(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'dropdownvariant4':
            const dd4Module = await import('./dropdown-variant-selector-v4.js');
            return new dd4Module.DropDownVariantSelectorV4(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'tilesvariant':
            const tv1Module = await import('./tiles-variant-selector-v1.js');
            return new tv1Module.TilesVariantSelectorV1(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'tilesvariant2-outlet':
            const tv2Module = await import('./tiles-variant-selector-v2.js');
            return new tv2Module.TilesVariantSelectorV2Outlet(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'relimgtilesvariant':
            const ri1Module = await import('./rel-images-tiles-variant-selector-v1.js');
            return new ri1Module.RelImagesTilesVariantSelectorV1(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'relimgtilesvariant2-outlet':
            const ri2Module = await import('./rel-images-tiles-variant-selector-v2.js');
            return new ri2Module.RelImagesTilesVariantSelectorV2Outlet(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'relimgtilesvariant3-outlet':
            const ri3Module = await import('./rel-images-tiles-variant-selector-v3.js');
            return new ri3Module.RelImagesTilesVariantSelectorV3Outlet(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        case 'fancyboxrelimgtilesvariant':
            const fb1Module = await import('./fancybox-tiles-variant-selector-v1.js');
            return new fb1Module.FancyBoxTilesVariantSelectorV1(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
    }

    new Notify(10000).error(`Variant selector implementation not found for name: '${name}'.`);
}